import { CALL_API } from '../middleware/api'

import { loadMember } from './member.js';
import { fetchCart } from './cart.js';

export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_FAILURE = 'USER_FAILURE'

// Fetches / validates the current user (server will check for presence and validity of JWT in cookie)
const fetchUser = () => ({
	[CALL_API]: {
		types: [ USER_REQUEST, USER_SUCCESS, USER_FAILURE ],
		endpoint: '/user/',
		method: 'POST',
		params: {},
		bad_response: 'Error retrieving user data from U-MAS database'
	}
})

// Fetches the current user - used on load and if the current user data is stale
// Relies on Redux Thunk middleware.
export const loadUser = () => (dispatch, getState) => {
  const user = getState().user;
  const now = Math.floor(Date.now() / 1000);
  if (user && user.exp >= now) {
    return null
  }

  return dispatch(fetchUser()).then(result => {
	  if(result.type === 'USER_SUCCESS' && result.response.member_no > 0){
		  dispatch(loadMember());
		  dispatch(fetchCart());
	  }
  });
}

